import { TabName } from './_enum-collections';

export class MSAIExceptionDisputeSearchAndFilterInput {
  public searchString!: string;
  public msaipExceptionDisputeId!: number;
  public requestType!: string;
  public requestReason!: string | null;
  public requestReasons!: string[];
  public action!: string | null;
  public actions!: string[];
  public requestKey!: number;
  public workshopName!: string;
  public customerOrgName!: string;
  public partnerInputParnterName!: string;
  public partnerInputMPNId!: number;
  public partnerInputCustomerTPId!: number;
  public status!: string | null;
  public statuses!: string[];
  public tabName!: TabName;
  public sortField!: string;
  public sortOrderDescending!: boolean;
  public page!: number;
  public pageSize!: number;

  public computeFilterListParams() {
    this.requestReason =
      this.requestReasons != null ? this.requestReasons.join('~') : null;

    this.action = this.actions != null ? this.actions.join('~') : null;
    this.status = this.statuses != null ? this.statuses.join('~') : null;
  }
}
